import moment from "moment";
import { TYPES } from "../actions";

const initialState = {
  aiMessages: null
};

export const aiMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_ALL_AI_MESSAGES_SUCCESS:
      return { ...state, 
        aiMessages: action.payload.data
      }

    case TYPES.ACTION_GET_ALL_AI_MESSAGES_FAIL:
      return { ...state, aiMessages: [] };

    case TYPES.ACTION_UPDATE_ALL_AI_MESSAGES_SUCCESS:
      var aiMessages = action.payload.data;

      return { ...state, 
        aiMessages: state.aiMessages.map(message => {
          return aiMessages.filter(msg => msg.id == message.id).length > 0? aiMessages.filter(msg => msg.id == message.id)[0]: message
        })
      }
      
    case TYPES.ACTION_DELETE_AI_MESSAGE_SUCCESS:
      return {
        ...state,
        aiMessages: state.aiMessages.filter(message => message.id !== action.payload.messageId)
      };
    default:
      return state;
  }
}
